import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const GuestDashboardPage = lazy(() => import('src/pages/dashboard/guest-dashboard'));

// ----------------------------------------------------------------------

export const guestdashboardRoutes = [
  {
    path: 'guestdashboard',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['guest', 'admin']} hasContent>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <GuestDashboardPage />, index: true },
    ],
  },
];
